module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens14-473184b66b8332fb7e49f3798ef8e4d6.jpg";